import * as React from 'react';
export function IconChevronRight() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "10",
    height: "10",
    viewBox: "0 0 7 10"
  }, React.createElement("path", {
    fill: "#0468FF",
    fillRule: "evenodd",
    d: "M1.707.293L.293 1.707 3.586 5 .293 8.293l1.414 1.414L6.414 5 1.707.293z",
    clipRule: "evenodd"
  }));
}